import { createSlice } from "@reduxjs/toolkit";
import { getEmployees } from "./_employeeAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const employeeList = createSlice({
  name: "employeeList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getEmployees.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getEmployees.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage;
        state.responseCode = payload.responseCode;
        state.totalRecord = payload.totalRecord || 0;        
      })
      .addCase(getEmployees.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
